export default __webpack_public_path__ + "static/pasckathon2.0-3691bc3275708f16fdbe9e869428ee49.png";